import { render, staticRenderFns } from "./BallClipRotate.vue?vue&type=template&id=7531c6ab"
import script from "./BallClipRotate.vue?vue&type=script&lang=js"
export * from "./BallClipRotate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports